export default __webpack_public_path__ + "158c225c07095b207d8e6eea56a78ae9.svg";